// themes/atlantic/config.js
export const config = {
  id: 'atlantic',
  name: 'Atlantic',
  icon: 'water',
  color: 'teal',
  welcomeMessage: "Welcome to the deep blue. How can I help you navigate the currents?",
  typography: "'Roboto', sans-serif",
  description: 'A deep, aesthetic ocean theme.',
  preview: 'Exploring the depths for an answer...',
  suggestedPrompts: [
    { text: 'Explore the depths' },
    { text: 'What lies beneath?' }
  ],
  animation: {
    wavePattern: 'animate-wave-pattern',
    float: 'animate-float',
    bubble: 'animate-bubble',
    bubbleFloat: 'animate-bubble-float'
  },
  // Add ocean-themed background effects
  backgroundEffects: {
    waves: true,
    bubbles: true,
    depth: true
  },
  // Add custom animations
  customAnimations: {
    waveSpeed: 'slow',
    bubbleDensity: 'medium',
    depthEffect: 'strong'
  }
};
